module.exports = __webpack_public_path__ + "img/BeccaF3.7aee127a.jpg";